export const constant = {

  
   // baseUrl: 'https://jethomeloans.azurewebsites.net/'
    baseUrl: 'https://jethl.com/api/'
   // baseUrl:  'http://127.0.0.1:3001/api/'
}

